<section class="hd-relation-info">
  @if (markdownUrl(); as url) {
    <markdown class="hd-relation-info__markdown" [src]="url" />
  }
</section>
